import React from 'react';
import styled from 'styled-components'

const Input = styled.input`
    &&& {
        padding: 5px 10px;
        width: 100%;
        border-color: #E5E5E5;
        border-width: 2px;
        &:focus {
            outline: none;
            box-shadow: none;
        }
    }
`

const TextBox = ({ value, placeholder, onChange }) => {

	const handleChange = (event) => {
		if (typeof onChange === 'function') {
			onChange(event, event.target.value);
		}
	}

	return (
		<Input type="text"
			placeholder={placeholder}
			value={value}
			onChange={(e) => handleChange(e)}
		/>
	)
}

export default TextBox;
